module.exports = __webpack_public_path__ + "static/media/eyeActive.05addb0b.png";